import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-icon" }
const _hoisted_2 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-skip-next-icon',
},
  __name: 'skip-next-icon',
  props: {
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 24 24",
      fill: __props.fill
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M16,18H18V6H16M6,18L14.5,12L6,6V18Z"
      }, null, -1)
    ]), 8, _hoisted_2))
  ]))
}
}

})